import PemeliharaanAsetApi from './PemeliharaanAsetApi';

export default PemeliharaanAsetApi;
